(() => {
  'use strict';
  const sizes = ['24', '48', '96'];
  function pageSizeUrl(href, size, resetPage) {
    const url = new URL(href, window.location.href);
    if (!sizes.includes(String(size))) return url;
    url.searchParams.set('view', 'sc-grid-' + size);
    if (resetPage) url.searchParams.delete('page');
    return url;
  }
  function init() {
    const select = document.querySelector('[data-sc-page-size]');
    if (!select || select.dataset.scBound) return;
    select.dataset.scBound = 'true';
    // Both filter forms reconstruct their query, so include the selected template.
    document.querySelectorAll('#TcgSearchFilterForm, #TcgCollectionFilters').forEach(form => {
      let input = form.querySelector('input[name="view"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'view';
        form.appendChild(input);
      }
      input.value = 'sc-grid-' + select.value;
    });
    select.addEventListener('change', () => {
      window.location.assign(pageSizeUrl(window.location.href, select.value, true).href);
    });
    // Keep page size through category, origin and pagination links, including
    // links rebuilt by the existing filtering scripts after the page loads.
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || link.hasAttribute('download')) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (!/\/(search|collections\/[^/]+)\/?$/.test(url.pathname)) return;
      if (/\/collections\/all\/?$/.test(url.pathname)) return;
      const view = url.searchParams.get('view');
      if (view && !/^sc-grid-(24|48|96)$/.test(view)) return;
      link.href = pageSizeUrl(url.href, select.value, false).href;
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
